import React, { useId, useState } from 'react';
import styled from 'styled-components';
import { SectionTitle } from './Crud/styles';

const Section = styled.section`
    border-radius: 12px;
    padding: clamp(16px, 3vw, 24px);
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: ${({ theme }) =>
        theme?.colors?.primary?.light ? `${theme.colors.primary.light}08` : 'rgba(59, 130, 246, 0.04)'};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    border: 1px solid
        ${({ theme }) =>
            theme?.colors?.primary?.light ? `${theme.colors.primary.light}40` : 'rgba(59, 130, 246, 0.12)'};
`;

const SectionHeading = styled(SectionTitle)`
    margin: 0;
    padding: 0;
    border: none;
`;

const SectionHeader = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    border-bottom: 1px solid transparent;
    background: none;
    cursor: pointer;
    text-align: left;
    font: inherit;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.primary?.main || '#3b5998'};

    &[aria-expanded='true'] {
        margin-bottom: clamp(12px, 2vw, 16px);
        padding-bottom: 12px;
        border-bottom-color: ${({ theme }) => theme.colors?.gray?.[200] || '#bcbcbc'};
    }

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.colors?.primary?.main || '#3b5998'};
        outline-offset: 4px;
        border-radius: 4px;
    }
`;

const SectionChevron = styled.span`
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(${({ $open }) => ($open ? '45deg' : '-45deg')});
    transition: transform 0.15s ease;
`;

const SectionBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: clamp(12px, 2vw, 16px);
    min-width: 0;
`;

export default function CollapsibleSection({ id, title, children, defaultOpen = true }) {
    const [open, setOpen] = useState(defaultOpen);
    const generatedId = useId();
    const baseId = id || generatedId;
    const titleId = `${baseId}-title`;
    const panelId = `${baseId}-panel`;

    return (
        <Section aria-labelledby={titleId}>
            <SectionHeading id={titleId}>
                <SectionHeader
                    type="button"
                    aria-expanded={open}
                    aria-controls={panelId}
                    onClick={() => setOpen((current) => !current)}
                >
                    {title}
                    <SectionChevron $open={open} aria-hidden="true" />
                </SectionHeader>
            </SectionHeading>
            {open ? <SectionBody id={panelId}>{children}</SectionBody> : null}
        </Section>
    );
}
